<template>
  <div class="lm-banner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">AI教育</span>
        <p>为了帮助合作伙伴以更低成本和更高效率加速大模型 AI 应用的落地，MoPaaS 构建了一个 AI 加速闭环生态体系，为合作伙伴的数字化转型、智能化升级和创新融合直接赋能。特别是通过 MoPaaS 的大模型 AI 应用型人才培训计划，精准满足不同企业和机构学员从大模型 AI 的基础认知、深入理解到实际应用的多层次需求。</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Lm-Banner',
}
</script>

<style>
.lm-banner {
  width: 100%;
  height: 38.5vw;
  overflow-y: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("../../assets/images/ailmbanner.png");
}

.lm-banner .center {
  width: auto !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 6vw;
}

.lm-banner .banner-overlay1 {
  padding-top: 8.3vw;
  color: #FFFFFF;
  text-align: left;
}


.lm-banner .banner-overlay1 .title {
  width: 49vw;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  display: inline;
}

.lm-banner .banner-overlay1 p {
  width: 49vw;
  font-size: 6px;
  font-weight:300;
  color: #FFFFFF;
  line-height: 10px;
  opacity: 0.8;
  margin-top: 6px;
}

.lm-banner .btn-contactUs {
  width: 24vw;
  margin-top: 6vw;
  height: 4vw;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 300;
  padding: 2vw;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/edu-banner.vue